// extracted by mini-css-extract-plugin
export var centerText = "_fg-8";
export var container = "_fg-0";
export var doughnutContainer = "_fg-7";
export var legend = "_fg-a";
export var legendItemColorDisplay = "_fg-b";
export var legendItemLabel = "_fg-d";
export var legendItemValue = "_fg-c";
export var lg = "_fg-5";
export var maxWidth = "_fg-9";
export var md = "_fg-4";
export var responsive = "_fg-6";
export var sm = "_fg-3";
export var xs = "_fg-2";
export var xxs = "_fg-1";